export enum EButtonType {
  Primary = "primary",
  Secondary = "secondary",
  SecondaryFill = "secondary-fill",
  Rounded = "rounded",
  Outline = "outline",
  MiniRounded = "miniRounded",
  iconRounded = "iconRounded",
  RoundedSecondary = "roundedSecondary",
  RoundedSecondaryNoMargin = "roundedSecondaryNoMargin",
  RoundedNoBackground = "roundedNoBackground"
}
